import {
  IS_LOGGED_IN,
  IS_LOGGED_OUT,
  UPDATE_CREDENTIALS,
  SET_AUTH_CHALLENGE,
  CLEAR_ALL,
  AUTO_VERIFYING_PHONE,
  UPDATE_USER,
} from '../constants';

// Legacy internal constant — kept for backwards compat with auth bootstrap
const UPDATE_AUTH_USER = 'UPDATE_AUTH_USER';

interface AuthState {
  user: any;
  cognito: any;
  fetched: boolean;
  fetching: boolean;
  auto_verifying_phone: boolean;
  auth_challenge: { type: 'MFA' | 'FORCE_PASSWORD'; user: any } | null;
}

const initialState: AuthState = {
  user: false,
  cognito: false,
  fetched: false,
  fetching: false,
  auto_verifying_phone: false,
  auth_challenge: null,
};

const authenticationReducer = (state = initialState, { type, payload }: { type: string; payload?: any }): AuthState => {
  switch (type) {
    case UPDATE_CREDENTIALS:
      return { ...state, cognito: payload };
    case SET_AUTH_CHALLENGE:
      return { ...state, auth_challenge: payload };
    case UPDATE_AUTH_USER:
    case UPDATE_USER:
      return { ...state, user: payload, fetched: true, fetching: false };
    case AUTO_VERIFYING_PHONE:
      return { ...state, auto_verifying_phone: payload };
    case IS_LOGGED_OUT:
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
};

export default authenticationReducer;
